const shared = {
  accent: '#E85D04',
  accentHover: '#D14F00',
  danger: '#DC2626',
  success: '#16A34A',
  radius: 12,
  font: '"Helvetica Neue", Helvetica, Arial, sans-serif',
  mono: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
};

export const light = {
  ...shared,
  mode: 'light',
  bg: '#F7F5F2',
  surface: '#FFFFFF',
  surfaceMuted: '#F0EDE8',
  border: 'rgba(20, 20, 20, 0.10)',
  text: '#1A1A1A',
  textMuted: 'rgba(26, 26, 26, 0.62)',
  textFaint: 'rgba(26, 26, 26, 0.40)',
  inputBg: '#FFFFFF',
  inputBorder: 'rgba(20, 20, 20, 0.16)',
  shadow: '0 8px 28px rgba(20, 20, 20, 0.06)',
};

export const dark = {
  ...shared,
  mode: 'dark',
  bg: '#121212',
  surface: '#1C1C1C',
  surfaceMuted: '#242424',
  border: 'rgba(255, 255, 255, 0.10)',
  text: '#F5F5F5',
  textMuted: 'rgba(245, 245, 245, 0.62)',
  textFaint: 'rgba(245, 245, 245, 0.38)',
  inputBg: '#1C1C1C',
  inputBorder: 'rgba(255, 255, 255, 0.14)',
  shadow: '0 8px 28px rgba(0, 0, 0, 0.35)',
};

export const getTheme = (isDark) => (isDark ? dark : light);
